module.exports = __webpack_public_path__ + "img/edit-reduction.d46f46d3.svg";